import { reactive, getCurrentInstance, computed, ref } from 'vue';
import popupUtil from '@/commons/popupUtil';
import RefType from '@/commons/wildcards/constants/RefType.js';
import { useCopyNewVoucher } from '@/views/utility/commons/copyNewVoucher.js';
import {
  showConfirm,
  showConfirmValidateCustom,
  showConfirmAutoGenerateParallel,
  showConfirmGenerateParallel,
  showErrorCustom,
  showError
} from '@/commons/globalMessage';
import baseDetailPopup from '@/views/base/baseDetailPopup';
import buPlanWithDrawAPI from '@/apis/bu/buPlanWithDrawAPI.js';
import bUTransferAPI from '@/apis/bu/bUTransferAPI';
export const useBUPlanWithdrawCommon = () => {
  const { proxy } = getCurrentInstance();
  const validateMasterControlMessage = ref([]);
  /**
   * Sự kiện click tiện ích
   * @param {*} item
   * tbngoc 23.07.2022
   */

  // Thêm import sinh chứng từ theo loại chỉ định
  const { clickItemCopyVoucher } = useCopyNewVoucher(proxy, 'BuPlanWithDrawDetails');

  /**
   * DVMINH 27.04.2023 sửa lại case sinh chứng từ theo loại truyền vào
   * */
  const clickItemHandleCommon = async item => {
    switch (item.command) {
      case proxy.$ms.constant.Command.Duplicate:
        // Nếu là sinh chứng từ cùng loại => gọi theo loại cũ
        // Sinh chứng từ khác loại => sừ dụng sinh theo loại
        if (item.refType && item.refType != proxy?.model?.ref_type) {
          clickItemCopyVoucher(item);
        }
        else {
          if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
            delete proxy._formParam.data.IsGenerateData;
          }
          proxy.duplicate({ id: proxy.model.ref_id });
        }
        break;

        break;
      case proxy.$ms.constant.Command.Delete:
        proxy.delete(proxy.model);
        break;

      case proxy.$ms.constant.Command.ShowWithDrawCash:
        proxy.addVoucher(RefType.BUPlanWithdrawCash, 'BUPlanWithdrawCashDetail');
        break;

      case proxy.$ms.constant.Command.ShowWithDrawDeposit:
        proxy.addVoucher(RefType.BUPlanWithdrawDeposit, 'BUPlanWithdrawDepositDetail');
        break;

      case proxy.$ms.constant.Command.ShowWithDrawTransfer:
        proxy.addVoucher(RefType.BUPlanWithdrawTransfer, 'BUPlanWithdrawTransferDetail');
        break;

      case proxy.$ms.constant.Command.ShowWithDrawSalaryTransfer:
        proxy.addVoucher(RefType.BUPlanWithdrawSalaryTransfer, 'BUPlanWithdrawSalaryTransferDetail');
        break;
    }
  };

  const validateGrid = (mode, valid) => {
    const me = proxy;
    let messages = [];
    let $refGrid = [];
    const scope = me.$el;
    let res = true;
    for (const key in me._gridDetails) {
      const refKey = me._gridDetails[key];
      $refGrid = me.$refs[refKey];
      //Lấy ra template ref của grid
      if ($refGrid && typeof $refGrid.validate === 'function') {
        messages.push($refGrid.validate(true));
        // Normalize lại message
        if (messages[0]) {
          let arrayMessage = messages[0].split(',');
          const distinctArr = arrayMessage.filter((value, index, self) => self.indexOf(value) === index);
          if (distinctArr) {
            messages[0] = distinctArr.join(';');
          }
        }
      }
    }
    messages = [...validateMasterControlMessage.value, ...messages];
    let message = messages.filter(x => x).join('; ').replaceAll(' đang bỏ trống','');
    let messageHelp = messages.filter(x => x && !['Đơn vị nhận', 'Tài khoản nhận'].includes(x)).join(';').replaceAll(' đang bỏ trống','');
    const messageHelpContent = messageHelp ? `Nếu bạn không thấy <span class="color-green">{1}</span> trên giao diện chứng từ, vui lòng xem hướng dẫn <a class='color-blue' target='_blank'  href="${window._helpLink?.layoutTemplate}">tại đây.</a>` : '';
    if (message) {
      res = false;
      const content = `Bạn cần nhập các thông tin <span class="color-green">{0}</span>. ${messageHelpContent}`;
      showConfirm(content.format(message, messageHelp), 'Cất chứng từ').then(res => {
        if (res) {
          //Lấy ra template ref của grid
          if ($refGrid && typeof $refGrid.validate === 'function') {
            $refGrid.validate(true, true)
            let controls = me._observeControls.filter(
              x =>
                x.$el.offsetWidth ||
                x.$el.offsetHeight ||
                x.$el.getClientRects().length ||
                /** Xử lý validate control khi ẩn */
                x.rules?.some(x => x.hide)
            );
            if (controls.length > 0) {
              const errors = controls.map(x => {
                if (typeof x.validate === 'function') {
                  const messageError = x.validate(true, true);
                }
              });
            }
            me.$nextTick(() => {
              me.focusFirstError(scope);
            })
          }
        } else {
          message = '';
          // HMDUC2 04/06/2024: Trong TH có lỗi và nhấn không cất thì focus vào ô lỗi đầu tiên - BUG 456017
          me.$nextTick(() => {
            me.focusFirstError(scope);
          })
          if (valid) {
            me.super('save', baseDetailPopup, mode)
          } else {
            me.$nextTick(() => {
              me.focusFirstError(scope);
            })
          }
        }
      });
    }
    return messages;
  }


  /**
   * Hàm dùng để focus vào ô lỗi đầu tiên
   * Created by LTDAT(22.06.2020)
   * */
  function focusFirstError(scope) {
    const me = proxy;
    const $el = scope || me.$el;
    me.$nextTick(() => {
      const firstErrorEl = $el.querySelector('.ms-editor .display-error input,.ms-editor .display-error a');
      if (firstErrorEl) {
        setTimeout(() => {
          if (firstErrorEl.tagName === 'INPUT') {
            firstErrorEl.focus();
          } else {
            firstErrorEl.click();
          }
        }, 50)
      }
    })
  }

  function validateComponents(mode) {
    const me = proxy;
    //refs của ms-validate
    // let controls = me._observeControls.filter(x => x.$el.closest('.control-group').style.display !== 'none');
    //let controls = me._observeControls.filter(x => x.$el.closest('.control-group').css('display') == 'none');
    let controls = me._observeControls.filter(
      x =>
        x.$el.offsetWidth ||
        x.$el.offsetHeight ||
        x.$el.getClientRects().length ||
        /** Xử lý validate control khi ẩn */
        x.rules?.some(x => x.hide)
    );
    let valid = true;
    if (controls.length > 0) {
      validateMasterControlMessage.value = [];
      const errors = controls.map(x => {
        if (typeof x.validate === 'function') {
          let messageError = x.validate(true);
          if (messageError && !messageError.includes("Không được để trống") && !messageError.includes('trong danh sách')) {
            validateMasterControlMessage.value.push(messageError);
          } else {
            valid = valid && (messageError == null || messageError == "");
          }
        }
      });
    }
    if (!valid) {
      return valid;
    }
    const validateGrids = me.validateGrid(mode, valid);

    valid = valid && !validateGrids.some(x => x);
    return valid;
  }

  /**
     * Xử lý validate các grid trên form chứng từ
     * @returns []=> Chứa message error của các grid
     */
  // function validateGrid() {
  //   const me = this;
  //   let messages = [];
  //   for (const key in me._gridDetails) {
  //     const refKey = me._gridDetails[key];
  //     const $refGrid = me.$refs[refKey];
  //     //Lấy ra template ref của grid
  //     if ($refGrid && typeof $refGrid.validate === 'function') {
  //       messages.push($refGrid.validate(true, true));
  //     }
  //   }

  //   const message = messages.find(x => x);
  //   if (message) {
  //     showError(message, 'Cất không thành công');
  //   }
  //   return messages;
  // }
  /**
     * Thực hiện sinh dữ liệu
     */
  async function actionAlertExistRelation(dataTrans, refType, title, formRelation) {
    let details = proxy.model;
    details.IsGenerateData = true;
    if (dataTrans) {
      if (dataTrans.ref_type != refType) {
        showErrorCustom(
          `Giấy rút này đã được sinh chứng từ ${proxy.$ms.commonFn.processXssValue(dataTrans.ref_type_name)} <span class="color-green">${proxy.$ms.commonFn.processXssValue(dataTrans.ref_no)}</span>. Bạn không thể sinh chứng từ ${proxy.$ms.commonFn.processXssValue(title)}`,
          `Không thể sinh chứng từ`,
          4
        );
      } else {
        // check quyền Sửa (vqphong - 14/12/2022)
        proxy.checkActionPermissionAlert(
          proxy.$ms.constant.Permission.Edit,
          proxy.$ms.constant.SubSystemCode.BUTransfer
        );
        showConfirm(
          `Bạn có muốn đồng bộ các thông tin đã cập nhật trên <span class="color-green">Giấy rút</span> với chứng từ ${proxy.$ms.commonFn.processXssValue(title)} số <span class="color-green">${proxy.$ms.commonFn.processXssValue(dataTrans.ref_no)}</span> không?`,
          `Đồng bộ chứng từ`
        ).then(async answer => {
          switch (answer) {
            case true:
              const valid = await validateGenerateVoucherPosted(bUTransferAPI, dataTrans);
              if (valid) {
                // Sinh chứng từ
                details.IsSyncData = true;
                popupUtil.show(formRelation, {
                  mode: proxy.$ms.constant.FormState.Edit,
                  id: proxy.model.relation_ref_id,
                  data: details,
                  options: {
                    submit: data => {
                      proxy.view({
                        id: proxy.model.ref_id,
                        mode: proxy.$ms.constant.FormState.View,
                      });
                    },
                  },
                });
              }

              break;
            case false:
              break;
          }
        });
      }
    } else {

      await buPlanWithDrawAPI.deleteRefRelationId({
        ref_id: proxy.model.ref_id,
      });
      // check quyền Thêm (vqphong - 14/12/2022)
      proxy.checkActionPermissionAlert(
        proxy.$ms.constant.Permission.Add,
        proxy.$ms.constant.SubSystemCode.BUTransfer
      );
      popupUtil.show(formRelation, {
        mode: proxy.$ms.constant.FormState.Add,
        data: details,
        options: {
          submit: data => {
            proxy.view({
              id: proxy.model.ref_id,
              mode: proxy.$ms.constant.FormState.View,
            });
          },
        },
      });
    }
  }

  /***
   * Override lại phần show thông báo lỗi khi sinh chứng từ
   * tbngoc 22.01.2024
   */
  const showErrorUnPosted = (error, record) => {
    const me = proxy;
    let dataError, title, mes, button;
    if (error.Data && error.Data.Code) {
      switch (error.Data.Code) {
        case me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Code:
          (dataError = error.Data.Data[0]),
            (title = me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Title),
            (mes = me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList.format(
              dataError ? dataError.exception_ref_no : ''
            )),
            (button = me.$ms.constant.PostedErrorCode.UnPost_ErrorExistInBUVoucherList_Button);
          //Hiển thị thông báo
          showConfirmValidateCustom(mes, title, button).then(answer => {
            if (answer) {
              //Nếu đồng ý xem bảng kê
              // Lấy form detail name
              let formDetailName = me.getFormDetailName(dataError ? dataError.exception_ref_type : '');
              // chọn xem bảng kê thì mở form bảng kê
              popupUtil.show(formDetailName, {
                mode: me.$ms.constant.FormState.View,
                id: dataError ? dataError.exception_ref_id : null,
                data: dataError,
                options: {},
              });
            }
          });
          break;
        case me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Code:
          //check là loại chứng từ bảng TH hay chứng từ ghi sổ
          //Lọc ra các chứng từ ghi sổ hoặc bảng tổng hợp
          let dataSummary =
            error.Data.Data.filter(x => x.ref_type == me.$ms.constant.RefType.GLVoucherSummaryTable) ?? [],
            dataVoucher = error.Data.Data.filter(x => x.ref_type == me.$ms.constant.RefType.GLPostedVoucher) ?? [],
            mess = '';

          let valSummary, valVoucher;
          // Danh sách mã các chứng từ bảng tổng hợp
          if (dataSummary && dataSummary.length) {
            dataSummary = proxy.$ms.commonFn.distinct(dataSummary);
            valSummary = dataSummary.map(x => x.ref_no).join('; ');
          }
          // Danh sách mã các chứng từ ghi sổ
          if (dataVoucher && dataVoucher.length) {
            dataVoucher = proxy.$ms.commonFn.distinct(dataVoucher);
            valVoucher = dataVoucher.map(x => x.ref_no).join('; ');
          }

          switch (true) {
            case dataSummary.length > 0 && dataVoucher.length > 0:
              //Trường hợp có cả ghi sổ và bảng th cùng loại
              mess = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_All.format(
                valSummary,
                record.ref_no,
                valVoucher
              );
              break;
            case dataSummary.length > 0 && dataVoucher.length == 0:
              //Trường hợp chỉ có bảng th cùng loại
              mess = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Summary.format(
                valSummary,
                record.ref_no
              );
              break;
            case dataSummary.length == 0 && dataVoucher.length > 0:
              //Trường hợp chỉ có ghi sổ
              mess = me.$ms.constant.PostedErrorCode.UnPost_ErrorUnPostExistInGLVoucherList_Voucher.format(
                valVoucher,
                record.ref_no
              );
              break;
            default:
              mess = '';
              break;
          }
          // Hiển thị cảnh báo
          if (mess != '') {
            showConfirm(mess, 'Cảnh báo bỏ ghi sổ').then(answer => {
              if (answer) {
                me.onUnPosted(record, false, error.Data.Code);
                proxy.generateVoucherAfterValidate();
              }
            });
          }
          break;
      }
    }
  }
  /**
     * Validate dữ liệu khi sinh chứng từ
     * tbngoc 22.01.2024
     */
  const validateGenerateVoucherPosted = async (api, record) => {
    const me = proxy;
    try {
      await api.validateGenerateVoucherPosted({
        Id: proxy.model.ref_id,
      });
      return true;
    } catch (ex) {
      //Show cảnh báo bỏ ghi sổ
      const error = ex.response?.data;
      //NOTE: Bỏ ghi sổ chỉ có error và yes/no
      switch (error.Data.Type) {
        //Nếu là lỗi thì hiện thông báo lỗi
        case me.$ms.constant.PostedErrorType.Error:
        case me.$ms.constant.PostedErrorType.Question:
          me.showErrorUnPosted(error, record);
          break;
      }
      return false;
    }
  };
  return {
    clickItemHandleCommon,
    focusFirstError,
    validateComponents,
    validateGrid,
    actionAlertExistRelation,
    showErrorUnPosted,
    validateGenerateVoucherPosted
  };
};
